import { TYPE } from "components/Form";
import { FLAG_FILTER_OPTIONS, GLOBAL_VALUE_TYPES, USER_TYPES_WITH_FILTER_ACCESS } from "constants/index";
import { GET_USERS } from "graphql/queries";

const TIMELINE_LIST_FILTERS_CONFIG = {
  created_date: {
    label: "Created Date",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.dateValues,
    transformValues: ({ min, max }) => [min || null, max || null],
    properties: {
      component: TYPE.datePicker,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  days_since_creation: {
    label: "Day(s) Since Creation",
    type: TYPE.minMaxInput,
    valuesType: GLOBAL_VALUE_TYPES.numericValues,
    properties: {
      type: "number",
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  event_target_type: {
    label: "Event Target Type",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ eventTargetType }) => eventTargetType,
    showOperator: true,
    properties: {
      placeholder: "Type an event target type...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  event_type: {
    label: "Event Type",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ eventType }) => eventType,
    showOperator: true,
    properties: {
      placeholder: "Type an event type...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  impersonator_id: {
    label: "Impersonator",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ id }) => id),
    showOperator: true,
    properties: {
      queryName: GET_USERS,
      queryKeyName: "users",
      placeholder: "Type a name...",
      searchQuery: (search) => ({ filters: { search } }),
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  is_impersonated: {
    label: "Is Impersonated?",
    type: TYPE.select,
    valuesType: GLOBAL_VALUE_TYPES.flagValues,
    transformValues: (value) => [value],
    properties: {
      options: FLAG_FILTER_OPTIONS,
      isClearable: true,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  key: {
    label: "Event Key",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ value }) => value),
    optionsFunc: ({ key }) => key,
    showOperator: true,
    properties: {
      placeholder: "Type an event key...",
      labelKey: "value",
      valueKey: "value",
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
  user_id: {
    label: "User",
    type: TYPE.tags,
    valuesType: GLOBAL_VALUE_TYPES.categoricalValues,
    transformValues: (value) => value?.map(({ id }) => id),
    showOperator: true,
    properties: {
      queryName: GET_USERS,
      queryKeyName: "users",
      placeholder: "Type a name...",
      searchQuery: (search) => ({ filters: { search } }),
      minLength: 0,
    },
    restrict: {
      roles: [USER_TYPES_WITH_FILTER_ACCESS.admin],
    },
  },
};

const TIMELINE_LIST_SORTING_OPTIONS = [
  {
    label: "Created timestamp",
    value: "created_at",
  },
];

const TIMELINE_LIST_SORTING_VALUES = TIMELINE_LIST_SORTING_OPTIONS.reduce((acc, { value }) => {
  acc[value] = value;
  return acc;
}, {});

export default TIMELINE_LIST_FILTERS_CONFIG;

export { TIMELINE_LIST_SORTING_OPTIONS, TIMELINE_LIST_SORTING_VALUES };
